import React, { Dispatch, SetStateAction } from 'react';

export interface visitorListItem {
  ai_id: string;
  connection_id: string;
  created_at: string;
  page_url: string;
  session_id: string;
  user_id: string;
}

export interface NotificationContext {
  visitorList: visitorListItem[];
  setVisitorList: Dispatch<SetStateAction<visitorListItem[]>>;
}

export const NotificationContext = React.createContext<NotificationContext>({} as NotificationContext);

export const useNotification = () => {
  const { setVisitorList, visitorList } = React.useContext(NotificationContext);

  return {
    visitorList,
    setVisitorList,
  };
};
